module.exports = __webpack_public_path__ + "img/星链联合华为共同助力中国时尚产业数字化.8e9e9c7c.png";